'use client';

import { Button, buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import * as Sentry from '@sentry/nextjs';
import Link from 'next/link';
import { useEffect } from 'react';

// Embed version at build time (e.g., git commit hash or timestamp)
const CURRENT_APP_VERSION = process.env.NEXT_PUBLIC_APP_VERSION || 'dev';
export default function GlobalError(props: {
  error: Error & {
    digest?: string;
  };
}) {
  useEffect(() => {
    // Check if error is chunk-related
    const isChunkError = props.error.message.includes('Loading chunk') || props.error.message.includes('Failed to fetch dynamically imported module');
    if (isChunkError) {
      // Get stored version from sessionStorage
      const storedVersion = sessionStorage.getItem('appVersion');

      // If no stored version or it differs from current version, reload
      if (!storedVersion || storedVersion !== CURRENT_APP_VERSION) {
        sessionStorage.setItem('appVersion', CURRENT_APP_VERSION);
        window.location.reload();
      }
    } else {
      // Capture other errors with Sentry
      Sentry.captureException(props.error);
    }
  }, [props.error]);
  return <html lang="en" data-sentry-component="GlobalError" data-sentry-source-file="global-error.tsx">
      <body className="flex min-h-dvh flex-col items-center justify-center bg-gray-100">
        <div className="flex min-h-dvh flex-col items-center justify-center bg-gray-100">
      <h1 className="mb-2 select-none text-9xl font-bold text-[#dbdbdb]">Error</h1>
      <h2 className="text-2xl font-bold">Something went wrong!</h2>
      <p className="mb-5 mt-2 text-gray-700 opacity-65">
        We're working on fixing this issue.
      </p>
      <p className="mb-5 text-gray-700 opacity-65">
        Please try reloading or clearing your browser cookies.
      </p>
      {process.env.NODE_ENV === 'development' && props.error.message && <pre className="my-3 max-w-lg overflow-auto text-sm">{props.error.message}</pre>}
      <div className="flex space-x-4">
         <Link href="/" className={cn(buttonVariants({
            className: 'hover:bg-[#4e46e6]/90 bg-[#4e46e6]'
          }))} data-sentry-element="Link" data-sentry-source-file="global-error.tsx">
          Go Home
        </Link>
      </div>
    </div>
      </body>
    </html>;
}